export const PRODUCTS_PER_PAGE = 180;
export const ONE_HUNDRED_PERCENT = 100;
export const TEN_PERCENT = 10;
export const ROUNDING_THRESHOLD = 9;
